














































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { AppUtil } from '../../utils/app.util';
import userService from '@/service/userService';
import SetCode from './setCode.vue';
import { Getter, Action, State } from "vuex-class";
import { LocalStorageService } from '@/service/storageService'
import { Constants } from "@/const/Constants";
@Component({
  components: { SetCode }
})

export default class SetPasswd extends Vue {
  private isLogined: boolean = false; // 是否登录状态
  private verifyType: number = 1; // 0 原始密码方式 1 手机短信方式
  private phoneNumber: string = ''; // 手机号
  private code: string = ''; // 验证码
  private oldPwd: string = ''; // 旧密码
  private newPwd: string = ''; // 新密码
  private preNewPwd: string = ''; // 确认密码
  private isShowHelp: boolean = false; // 是否显示帮助
  private appInfoAtiak: any = userService.appInfoAtiak; // 应用信息
  @State("userInfo") userInfo!: any;
  @Action('SET_SHOW_ACCOUNT_DIALOG_ASYN') handleAccountDialog!: (data: boolean) => void
  @Action('SET_ACCOUNT_DIALOG_TYPE_ASYN') changeAccountType!: (data: string) => void
  private created() {
    this.isLogined = AppUtil.isNotEmpty(this.userInfo); // 判断是否登录状态 
    /*  this.phoneNumber = this.userInfo.mobile;
     if (AppUtil.isNotEmpty(this.phoneNumber)) {
       this.verifyType = 1;
     } */
  }
  getSendCode(res: boolean) { // 获取验证码
  }

  // 打开帮助
  toHelp() {
    window.location.href = "/user/help";
    //window.open("/user/help", "_blank");
  }

  accept() {
    if (this.isLogined && this.verifyType == 0) {
      // 旧密码模式
      if (AppUtil.isEmpty(this.oldPwd)) {
        this.$Message.error("请输旧密码!");
        return;
      }
    } else if (this.isLogined && this.verifyType == 1) {
      // 已登录手机短信模式
      if (AppUtil.isEmpty(this.phoneNumber) || !this.validCode()) {
        return;
      }
    } else if (!this.validPhone() || !this.validCode()) {
      // 未登录手机短信模式重置密码
      return;
    }
    // 验证密码信息
    if (!this.validPasswd()) {
      return;
    }

    if (this.isLogined && this.verifyType == 0) {//根据旧密码修改密码
      userService.updatePasword(this.newPwd, this.oldPwd).then((data: any) => {
        this.modifyPwdAfter(data, this.appInfoAtiak);
      });
    } else if (this.isLogined && this.verifyType == 1) {//根据手机号修改密码
      userService.updatePaswordByMobile(this.phoneNumber, this.code, this.newPwd).then((data) => {
        this.modifyPwdAfter(data, this.appInfoAtiak);
      });
    }else if (!this.isLogined && this.verifyType == 1) {//根据手机号重置密码 
      userService.updatePaswordByMobile(this.phoneNumber, this.code, this.newPwd).then((data: any) => {
        this.modifyPwdAfter(data, this.appInfoAtiak);
      });
    }
  }

  validPhone(): boolean {
    if (AppUtil.isEmpty(this.phoneNumber)) {
      this.$Message.error("请输入手机号码!");
      return false;
    } else if (!AppUtil.isPhoneNumber(this.phoneNumber)) {
      this.$Message.error("请输入正确手机号!!");
      return false;
    }
    return true;
  }

  validPasswd(): boolean {
    if (AppUtil.isEmpty(this.newPwd)) {
      this.$Message.error("请输入8-16位新密码!");
      return false;
    } else {
      const passwordReg =
        /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,16}$/;
      if (!passwordReg.test(this.newPwd)) {
        this.$Message.error("密码长度8~16位，须包含大、小写字母、数字、符号中任意三种元素!");
        return false;
      }
    }

    if (AppUtil.isEmpty(this.preNewPwd)) {
      this.$Message.error("请输入确认密码!");
      return false;
    } else if (this.newPwd != this.preNewPwd) {
      this.$Message.error("两次输入的密码不一样,请修改!");
      return false;
    } else {
      return true;
    }
  }

  validCode(): boolean {
    if (AppUtil.isEmpty(this.code)) {
      this.$Message.error("请输入验证码!");
      return false;
    } else if (this.code.length != 6) {
      this.$Message.error("验证码不正确!");
      return false;
    }
    return true;
  }

  private modifyPwdAfter(data: any, atiak: string) {
    if (data && data.success) {
      if (this.isLogined) {
        userService.loginOut().then(() => {
          userService.initVisitorsToken(atiak).then((data: any) => {
            if (data && data.success) {
              LocalStorageService.remove(Constants.Storage_Local.Login_Time);
              this.openOk('updatePasswd');
            }
          });
        });
      } else {
        this.$Message.error("密码重置成功, 请登录!");
        this.openOk('reSetPasswd');
        return;
      }
    } else {
      this.$Message.error(AppUtil.isEmpty(data.errorText) ? "密码修改失败!" : data.errorText);
    }
  }

  openOk(actType: string) {
    this.$Modal.confirm({
      title: '提示',
      content: actType == 'reSetPasswd' ? '密码重置成功, 请登录!' : '密码修改成功!',
      onOk: () => {
        if (actType == 'reSetPasswd') { // 重置密码
          this.handleAccountDialog(true)
          this.changeAccountType('login')
        }
      },
      onCancel: () => {

      }
    });

  }
}


